import { IPlan, ISubscription, ISubscriptionsState } from '@/@types'

import { MutationTree } from 'vuex'

const mutations: MutationTree<ISubscriptionsState> = {
  PARTNER_STACK_FLOW_UPDATED: (state, isInPartnerFlow: boolean) => {
    state.isInPartnerFlow = isInPartnerFlow
  },
  THREE_DS_FLOW_UPDATED: (state, isIn3dsFlow: boolean) => {
    state.isIn3dsFlow = isIn3dsFlow
  },
  PAYMENT_ENTRIES_UPDATED: (state, entryAndValue: { value: string; input: string }) => {
    const { value, input } = entryAndValue
    state.paymentEntries[value] = input
  },
  PAYMENT_METHOD_UPDATED: (state, paymentMethod: string) => {
    state.paymentMethod = paymentMethod
  },
  PROMOTIONAL_FIELD_UPDATED: (state, promotionalField: string) => {
    state.promotionalField = promotionalField
  },
  PAYMENT_METHOD_ON_FILE_UPDATED: (state, paymentMethod: string) => {
    state.paymentMethodOnFile = paymentMethod
  },
  USERS_CURRENT_SUBSCRIPTIONS_UPDATED: (state, usersCurrentSubscriptions: Array<IPlan>) => {
    state.usersCurrentSubscriptions = usersCurrentSubscriptions
  },
  USER_HAS_SUBSCRIPTION_UPDATED: (state, userHasSubscription: boolean) => {
    state.userHasSubscription = userHasSubscription
  },
  USER_SUBSCRIPTIONS_WITH_PASSES_UPDATED: (
    state,
    usersCurrentSubscriptionsWithPasses: Array<ISubscription>
  ) => {
    state.usersCurrentSubscriptionsWithPasses = usersCurrentSubscriptionsWithPasses
  },
}

export default mutations
